











































































































































import { Component, Prop, Vue, Emit  } from 'vue-property-decorator';
import url from 'url';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import {IStatisticsSummaryDetail} from '../shared/services/models/StatisticsSummaries';
import {IInterface, IMultipleOutputs} from '../shared/services/models/Interface';
import {ISetting} from '../shared/services/models/Setting';
import { IGeoIP } from '../shared/services/models/GeoIP';
import moment from 'moment';


@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
            // @ts-ignore
        GeoLocationsComponent: require('../shared/components/GeoLocation.vue').default,
    },
    computed: {
        ...mapState(['locations', 'updating']),
    },
    methods: {
        ...mapActions(['loadGeoIP']),
    },
})
export default class DashboardComponent extends Vue {
    private locations!: { [key: string]: IGeoIP };
    private updating!: boolean;

    @Prop() private interfaceObject!: IInterface;
    @Prop() private statistics!: IStatisticsSummaryDetail;
    @Prop() private shiftDown!: boolean;
    @Prop({ default: [] }) private settings!: ISetting[];


    private ExternalIPKey: string = 'server.external_ip';

    // @ts-ignore
    @Emit('start')
    // @ts-ignore
    private StartInterface(): void {
        const doNothind = true;
    }

    // @ts-ignore
    @Emit('stop')
    // @ts-ignore
    private StopInterface(): void {
        const doNothind = true;
    }

    // @ts-ignore
    @Emit('restart')
    // @ts-ignore
    private RestartInterface(): void {
        const doNothind = true;
    }

    private mounted() {
        // @ts-ignore
        this.loadGeoIP();
    }

    private get Interface(): IInterface {
        return this.interfaceObject;
    }

    private get Active(): boolean {
        return this.interfaceObject.state === 1;
    }

    private get Name(): string {
        return this.interfaceObject.name;
    }

    private get Id(): string {
        return this.interfaceObject.id;
    }

    private get Input(): string[] | IMultipleOutputs {
        if (this.interfaceObject.live) {
            return this.interfaceObject.live.input;
        }

        return this.interfaceObject.input;
    }

    private get Output(): string[] | IMultipleOutputs {
        if (this.interfaceObject.live) {
            return this.interfaceObject.live.output;
        }

        return this.interfaceObject.output;
    }

    private get ModeString(): string {
        if (Array.isArray(this.Input) && Array.isArray(this.Output)) {
            if (this.Input.length > 0 && this.Output.length > 0) {
                const input: boolean = this.isRX_TX(this.Input[0]);
                const output: boolean = this.isRX_TX(this.Output[0]);

                if (input && !output) {
                    return 'rx';
                } else if (!input && output) {
                    return 'tx';
                } else if (input && output) {
                    return 'relay';
                } else {
                    if (this.getProtocol(this.Input[0]) === 'cinegy_route') {
                        return 'forwarder';
                    }
                    return 'local';
                }
            }

        }

        return 'n/a';
    }

    private get Protocols(): string {
        const mode: string = this.ModeString;
        if (mode === 'rx' && Array.isArray(this.Input)) {
            return this.getProtocol(this.Input[0]);
        } else if (mode === 'tx' && Array.isArray(this.Output)) {
            return this.getProtocol(this.Output[0]);
        } else if ((mode === 'relay' || mode === 'local') && Array.isArray(this.Input)) {
            const input = this.getProtocol(this.Input[0]);

            if ( Array.isArray(this.Output)) {
                const output = this.getProtocol(this.Output[0]);

                if (input !== output) {
                    return `${input}/${output}`;
                } else {
                    return `${input}`;
                }
            }
        } else if (mode === 'forwarder' && Array.isArray(this.Output)) {
            const output = this.getProtocol(this.Output[0]);

            return `router/${output}`;
        }

        return '';
    }

    private get Settings(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        if (this.settings) {
            this.settings.forEach((s) => {
                ret[s.key] = s.value;
            });
        }

        return ret;
    }

    private get InputCount(): number {
        if (this.statistics) {
            if (this.statistics.connected_input_clients) {
                return this.statistics.connected_input_clients.length;
            }
        }
        return 0;
    }

    private get OutputCount(): number {
        if (this.statistics) {
            if (this.statistics.connected_output_clients) {
                return this.statistics.connected_output_clients.length;
            }
        }
        return 0;
    }

    private get StartedAt(): string {
        const updated: boolean = this.updating;

        if (this.Active && this.interfaceObject && this.interfaceObject.live) {
            const startedAt: string = this.interfaceObject.live.started_at.substring(0, 19).replace('T', ' ');
            return startedAt;
        }

        return '';
    }

    private get RunningTime(): string {
        const updated: boolean = this.updating;
        if (this.Active && this.interfaceObject && this.interfaceObject.live) {
            const startedAt: string = this.interfaceObject.live.started_at.substring(0, 19) + 'Z';
            return moment(startedAt).fromNow();
        }

        return '';
    }

    private get RunningTimeDetails(): string {
        const updated: boolean = this.updating;

        // https://stackoverflow.com/questions/49385109/get-days-hour-and-minutes-diff-moment-js
        if (this.Active && this.interfaceObject && this.interfaceObject.live) {

            const startedAt: string = this.interfaceObject.live.started_at.substring(0, 19) + 'Z';
            const duration = moment.duration(moment(new Date()).diff(moment(startedAt)));

            // Get Days
            const days = Math.floor(duration.asDays()); // .asDays returns float but we are interested in full days only
            const daysFormatted = days ? `${days}d ` : ''; // if no full days then do not display it at all

            // Get Hours
            const hours = this.zeroPad(duration.hours(), 2);
            const hoursFormatted = `${hours}:`;

            // Get Minutes
            const minutes = this.zeroPad(duration.minutes(), 2);
            const minutesFormatted = `${minutes}:`;

            // Get Minutes
            const seconds = this.zeroPad(duration.seconds(), 2);
            const secondsFormatted = `${seconds}`;

            return [daysFormatted, hoursFormatted, minutesFormatted, secondsFormatted].join('');
        }

        return '';
    }

    private GeoCity(ip: string): string {
        const geoip: IGeoIP | undefined = this.GetGeo(ip);
        if (geoip) {
            if (geoip.status === 'success') {
                if (geoip.city) {
                    return geoip.city;
                }
            }
        }
        return 'n/a';
    }

    private GeoCountryCode(ip: string): string {
        const geoip: IGeoIP | undefined = this.GetGeo(ip);
        if (geoip) {
            if (geoip.status === 'success') {
                if (geoip.countryCode) {
                    return geoip.countryCode.toLowerCase();
                }
            }
        }
        return 'n/a';
    }

    private startInterface(): void {
        this.$bvModal.msgBoxConfirm(`Start ${this.Name}`, {
            title: 'Start Interface',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                this.StartInterface();
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private restartInterface(): void {
        this.$bvModal.msgBoxConfirm(`Restart ${this.Name}`, {
            title: 'Restart Interface',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                this.RestartInterface();
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private stopInterface(): void {
        this.$bvModal.msgBoxConfirm(`Stop ${this.Name}`, {
            title: 'Stop Interface',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                this.StopInterface();
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private getProtocol(uri: string): string {
        if (uri) {
            if (uri.indexOf(':') !== -1 ) {
                const ret: string = uri.toLowerCase().substring(0, uri.indexOf(':'));

                if (ret === 'http' && uri.toLowerCase().indexOf('getvirtual') !== -1) {
                    return 'cinegy_route';
                }

                return ret;
            }
        }

        return '';
    }

    private isRX_TX(uri: string): boolean {
        let ret: boolean = false;
        if (uri) {
            if (uri.toLowerCase().startsWith('srt://') ||
                uri.toLowerCase().startsWith('rist://') ||
                uri.toLowerCase().startsWith('zixi://')) {
                ret = true;
            }
        }
        return ret;
    }

    private get Bitrate(): string {
        let ret: string = '0.00';

        if (this.Active && this.statistics && this.statistics.interface_id === this.interfaceObject.id) {
            if (this.ModeString === 'rx') {
                ret = this.statistics.in_bitrate.toFixed(2);
            } else if (this.ModeString === 'tx' || this.ModeString === 'forwarder') {
                ret = this.statistics.out_bitrate.toFixed(2);
            } else if (this.ModeString === 'relay' || this.ModeString === 'relay') {
                ret = `${this.statistics.in_bitrate.toFixed(2)}/${this.statistics.out_bitrate.toFixed(2)}`;
            }
        }

        return ret;
    }

    private get BitrateIn(): string {
        let ret: string = '0.00';

        if (this.Active && this.statistics && this.statistics.interface_id === this.interfaceObject.id) {
                ret = this.statistics.in_bitrate.toFixed(2);
        }

        return ret;
    }

    private get BitrateOut(): string {
        let ret: string = '0.00';

        if (this.Active && this.statistics && this.statistics.interface_id === this.interfaceObject.id) {
                ret = this.statistics.out_bitrate.toFixed(2);
        }

        return ret;
    }

    private showInfo() {
       this.$bvModal.show('modal-info-' + this.Id);
    }

    private get ConnectURLOutput(): string {
        if (Array.isArray(this.Output)) {
            const output: string = this.Output[0];

            return this.ConnectURL(output);
        }

        return '';
    }

    private get Locations(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        this.statistics.connected_input_clients.forEach((i) => {
            const r = i.ip;

            if (ret[r] === undefined) {
                if (this.locations[r] === undefined) {
                    // @ts-ignore
                    this.loadGeoIP(r);
                }
                ret[r] = r;
            }
        });

        this.statistics.connected_output_clients.forEach((i) => {
            const r = i.ip;

            if (ret[r] === undefined) {
                if (this.locations[r] === undefined) {
                    // @ts-ignore
                    this.loadGeoIP(r);
                }
                ret[r] = r;
            }
        });

        return ret;
    }

    private get ConnectURLInput(): string {
        if (Array.isArray(this.Input)) {
            const input: string = this.Input[0];

            return this.ConnectURL(input);
        }

        return '';
    }

    private ConnectURL(str: string): string {
        const u = url.parse(str, false, false);

        if (this.getProtocol(str) === 'srt') {
            if (str.toLowerCase().startsWith('srt://:')) { // listner
                return `srt://${this.Settings[this.ExternalIPKey]}:${u.port}`;
            }

            return `srt://:${u.port}`;
        } else if (this.getProtocol(str) === 'rist') {
            if (str.toLowerCase().startsWith('rist://:')) { // listner
                return `rist://${this.Settings[this.ExternalIPKey]}:${u.port}`;
            }

            return `rist://:${u.port}`;
        }
        if (str.indexOf('?') !== -1) {
            return str.substring(0, str.indexOf('?'));
        }

        return str;
    }

    private GetGeo(ip: string): IGeoIP| undefined {
        const l = this.Locations;
        return this.locations[ip];
    }


    private copyURLToClipboard(str: string): void {
        try {
            const el = document.createElement('textarea');
            el.addEventListener('focusin', (e) => e.stopPropagation());
            el.value = str;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        } catch (E) {
            window.console.log(E);
        }
        this.$bvToast.toast('Copied to clipborad', {
            title: 'SRT URL',
            variant: 'info',
            solid: true,
        });
    }

    private copyOutputURLToClipboard(): void {
        this.copyURLToClipboard(this.ConnectURLOutput);
    }

    private copyInputURLToClipboard(): void {
        this.copyURLToClipboard(this.ConnectURLInput);
    }

    private zeroPad(nr: number, places: number): string {
        return String(nr).padStart(places, '0');
    }

    private destroyed() {
        // todo
    }
}
